// ADR-0001 (artaNftBE/docs/adr): caile publice canonice. Acelasi tipar ca App\Seo\UrlPublic din BE.
const prefixMembru = (type) => (type === 'colectionar' ? '/colectionari' : '/artisti');

export const membruPath = (type, slug) => `${prefixMembru(type)}/${encodeURIComponent(slug)}`;

export const lucrarePath = (type, membruSlug, slug) =>
    `${membruPath(type, membruSlug)}/lucrari/${encodeURIComponent(slug)}`;
